export default __webpack_public_path__ + "static/media/hero-load.d22b2ae5.mp4";